<template>
  <section
    v-if="tab === 8"
    class="user-information p-4 bg-white box-shaddow20 border-r-10"
  >
    <div class="d-flex align-items-center justify-content-between pb-4">
      <div class="d-flex align-items-center gap-5 custom-border-right px-2">
        <NotificationsIcon />
        <h4 class="font-w-400 font-s-18 text-color-theme-dark m-0">
          لیست پیغام ها
        </h4>
      </div>
    </div>
    <template v-if="status">
      <b-skeleton></b-skeleton>
    </template>
    <template v-else>
      <ul class="panel-notification-container" v-if="notifications">
        <router-link
          class="panel-notification-items border-bottom py-3"
          v-for="(notification, index) in allNotifications"
          :key="index"
          tag="li"
          :to="notification.to"
        >
          <div class="panel-notification-title">
            <span
              >{{ notification.title }}
              <span
                class="badge badge-danger mr-1"
                style="transform: translateY(-1px)"
                v-if="!notification.read"
                >جدید</span
              >
            </span>
            <span class="created-at">{{
              moment(notification.created_at).format("HH:mm YYYY/MM/DD")
            }}</span>
          </div>
          <!-- <div style="opacity: 0">
            <span>{{ notification.title }}</span>
            <span
              >تاریخ:
              {{
                moment(notification.created_at).format("HH:mm YYYY/MM/DD ")
              }}</span
            >
          </div> -->
          <div class="panel-notification-description">
            <span class="font-w-500 font-s-13 text-warning">پیام :</span>
            {{ notification.description }}
          </div>
        </router-link>
      </ul>
      <div class="w-100 text-center py-5" v-else>
        <svg
          width="66"
          height="65"
          viewBox="0 0 66 65"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M33.0545 55.602C26.744 55.602 20.4336 54.5999 14.4482 52.5957C12.1732 51.8103 10.4399 50.2124 9.68155 48.127C8.89613 46.0415 9.16696 43.7395 10.4128 41.6811L13.5274 36.5082C14.1774 35.4249 14.7732 33.2582 14.7732 31.9853V24.1582C14.7732 14.0832 22.9795 5.87695 33.0545 5.87695C43.1295 5.87695 51.3357 14.0832 51.3357 24.1582V31.9853C51.3357 33.2311 51.9315 35.4249 52.5815 36.5353L55.669 41.6811C56.8336 43.6311 57.0503 45.9874 56.2649 48.127C55.4795 50.2665 53.7732 51.8915 51.6336 52.5957C45.6753 54.5999 39.3649 55.602 33.0545 55.602ZM33.0545 9.93945C25.2274 9.93945 18.8357 16.304 18.8357 24.1582V31.9853C18.8357 33.9624 18.0232 36.8874 17.0211 38.5936L13.9065 43.7665C13.3107 44.7686 13.1482 45.8249 13.5003 46.7186C13.8253 47.6395 14.6378 48.3436 15.7482 48.7228C27.069 52.5145 39.067 52.5145 50.3878 48.7228C51.3628 48.3978 52.1211 47.6665 52.4732 46.6915C52.8253 45.7165 52.744 44.6603 52.2024 43.7665L49.0878 38.5936C48.0586 36.8332 47.2732 33.9353 47.2732 31.9582V24.1582C47.2732 16.304 40.9086 9.93945 33.0545 9.93945Z"
            fill="#C4C1C1"
          />
          <path
            d="M38.0915 10.6713C37.9019 10.6713 37.7123 10.6442 37.5228 10.59C36.7373 10.3734 35.979 10.2109 35.2478 10.1025C32.9457 9.80462 30.7248 9.96712 28.6394 10.59C27.8811 10.8338 27.0686 10.59 26.554 10.0213C26.0394 9.45254 25.8769 8.64004 26.1748 7.90879C27.2853 5.06504 29.9936 3.19629 33.0811 3.19629C36.1686 3.19629 38.8769 5.03796 39.9873 7.90879C40.2582 8.64004 40.1228 9.45254 39.6082 10.0213C39.2019 10.4546 38.6332 10.6713 38.0915 10.6713Z"
            fill="#C4C1C1"
          />
          <path
            d="M33.0537 61.7773C30.3725 61.7773 27.7725 60.694 25.8766 58.7982C23.9808 56.9023 22.8975 54.3023 22.8975 51.6211H26.96C26.96 53.219 27.61 54.7898 28.7475 55.9273C29.885 57.0648 31.4558 57.7148 33.0537 57.7148C36.412 57.7148 39.1475 54.9794 39.1475 51.6211H43.21C43.21 57.2273 38.66 61.7773 33.0537 61.7773Z"
            fill="#C4C1C1"
          />
        </svg>
        <h5 class="font-w-500 font-s-18 text-color-theme-grey2 mt-3">
          پیامی وجود ندارد
        </h5>
      </div>
    </template>
  </section>
</template>

<script>
import { BSkeleton } from "bootstrap-vue";
import NotificationsIcon from "@/parts/Front/components/Icon/panelIcons/Notifications.vue";
export default {
  components: { BSkeleton, NotificationsIcon },
  props: { tab: { Number } },
  computed: {
    status() {
      return this.$store.getters["front/getFavoriteStatus"];
    },
    notifications() {
      return this.$store.getters["front/getNotifications"];
    },
    allNotifications() {
      return this.notifications.items.map((item) => {
        return item.getNotification();
      });
    },
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
  },
  mounted() {
    if (this.isLogin) {
      this.$store.dispatch("front/getNotficationsFromServer");
    }
  },
};
</script>

<style scoped>
.panel-notification-container {
  max-height: 500px;
  overflow-y: scroll;
  padding: 8px;
}
.panel-notification-container::-webkit-scrollbar {
  display: none;
}
.panel-notification-items {
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  overflow: auto;
}
.panel-notification-title {
  display: flex;
  justify-content: space-between;
  font-size: 23px;
}
.panel-notification-title .created-at {
  font-size: 16px;
  color: #5c5c5c;
  word-spacing: 6px;
}
</style>
